import React from "react";

import { View, ScrollView } from "react-native";

import Footer from "../common/footer/index";
import LoadingIndicator from "../common/LoadingIndicator";
import appStyles from "../../appStyles";
import GoalsList from "./goals/GoalsList";
import Header from "../common/header";

export default class ResolutionGemsPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: true,
      gems: {},
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.refreshPage();
        },
      );
    } else {
      this.refreshPage();
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params?.args;
    } else {
      return this.controller.state.screenArgs?.args?.args;
    }
  }

  refreshPage = async () => {
    let { gems } = this.getArgs() || {};

    if (!gems) {
      this.controller.changePage("rn:resolution");
      return;
    }

    this.setState((state) => ({
      ...state,
      isLoading: false,
      gems,
    }));
  };

  render() {
    const { isLoading, gems } = this.state;

    return (
      <View style={appStyles.container}>
        <Header
          controller={this.controller}
          title="Gems"
          subTitle="Your past goals"
          hideAvatar
          returnPage="rn:resolution"
        />

        {isLoading ? (
          <LoadingIndicator isLoading={isLoading} />
        ) : (
          <ScrollView
            style={appStyles.scrollView}
            contentContainerStyle={appStyles.scrollViewContent}
          >
            <GoalsList
              goals={gems}
              controller={this.controller}
              hasGem={true}
              showPresets={false}
            />
          </ScrollView>
        )}

        {this.controller.hasNavigation() ? null : (
          <View style={appStyles.footerOptions}>
            <Footer controller={this.controller} selectedPage="resolution" />
          </View>
        )}
      </View>
    );
  }
}
